function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TreeNode from './TreeNode';
import nodeShape from './nodeShapeWithChildren';
import { getNodeArrayByType, removeNodeArrayByType } from './funcs';

require('xps-style/core/checkboxtree.css');

var CheckboxTree = /*#__PURE__*/function (_Component) {
  _inherits(CheckboxTree, _Component);

  var _super = _createSuper(CheckboxTree);

  function CheckboxTree(props) {
    var _this;

    _classCallCheck(this, CheckboxTree);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onCheck", function (node) {
      var _this$props = _this.props,
          onCheck = _this$props.onCheck,
          checkedArray = _this$props.checkedArray,
          nodes = _this$props.nodes;
      return checkedArray.includes(node.value) ? onCheck(removeNodeArrayByType({
        nodes: nodes,
        typedArray: checkedArray,
        remove: [node.value],
        applyToChildren: true
      })) : onCheck(getNodeArrayByType({
        nodes: nodes,
        typedArray: [node.value].concat(_toConsumableArray(checkedArray)),
        applyToChildren: true
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "onExpand", function (node) {
      var _this$props2 = _this.props,
          onExpand = _this$props2.onExpand,
          expandedArray = _this$props2.expandedArray;
      return expandedArray.includes(node.value) ? onExpand(expandedArray.filter(function (val) {
        return node.value !== val;
      })) : onExpand([].concat(_toConsumableArray(expandedArray), [node.value]));
    });

    _defineProperty(_assertThisInitialized(_this), "getDisabledState", function (node, parent) {
      return parent.disabled ? true : Boolean(node.disabled);
    });

    _defineProperty(_assertThisInitialized(_this), "renderChildNodes", function (node, level) {
      return node.children !== null && node.expanded ? _this.renderTreeNodes(node.children, level + 1) : null;
    });

    var _this$props3 = _this.props,
        _checkedArray = _this$props3.checkedArray,
        disabledArray = _this$props3.disabledArray,
        _expandedArray = _this$props3.expandedArray,
        onLoad = _this$props3.onLoad,
        _nodes = _this$props3.nodes;
    onLoad({
      checked: getNodeArrayByType({
        nodes: _nodes,
        typedArray: _checkedArray,
        applyToChildren: true
      }),
      disabled: getNodeArrayByType({
        nodes: _nodes,
        typedArray: disabledArray,
        applyToChildren: true
      }).array,
      expanded: getNodeArrayByType({
        nodes: _nodes,
        typedArray: _expandedArray,
        applyToChildren: false
      }).array
    });
    return _this;
  }

  _createClass(CheckboxTree, [{
    key: "getFormattedNodes",
    value: function getFormattedNodes(nodes) {
      var _this2 = this;

      var _this$props4 = this.props,
          checkedArray = _this$props4.checkedArray,
          expandedArray = _this$props4.expandedArray,
          disabledArray = _this$props4.disabledArray;
      return nodes.map(function (node) {
        return _objectSpread(_objectSpread({}, node), {}, {
          checked: checkedArray.includes(node.value),
          disabled: disabledArray.includes(node.value),
          expanded: expandedArray.includes(node.value),
          children: Array.isArray(node.children) && node.children.length > 0 ? _this2.getFormattedNodes(node.children) : null
        });
      });
    }
  }, {
    key: "getCheckState",
    value: function getCheckState(node) {
      if (node.children === null) return node.checked ? 1 : 0;
      if (this.isEveryChildChecked(node)) return 1;
      if (this.isSomeChildChecked(node)) return 2;
      return 0;
    } // eslint-disable-next-line no-confusing-arrow

  }, {
    key: "isEveryChildChecked",
    value: function isEveryChildChecked(node) {
      var _this3 = this;

      var checkedArray = this.props.checkedArray;
      return node.children.every( // eslint-disable-next-line no-confusing-arrow
      function (child) {
        return child.children !== null ? _this3.isEveryChildChecked(child) : checkedArray.includes(child.value);
      });
    }
  }, {
    key: "isSomeChildChecked",
    value: function isSomeChildChecked(node) {
      var _this4 = this;

      var checkedArray = this.props.checkedArray;
      return node.children.some( // eslint-disable-next-line no-confusing-arrow
      function (child) {
        return child.children !== null ? _this4.isSomeChildChecked(child) : checkedArray.includes(child.value);
      });
    }
  }, {
    key: "renderTreeNodes",
    value: function renderTreeNodes(nodes) {
      var _this5 = this;

      var level = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var _this$props5 = this.props,
          disabled = _this$props5.disabled,
          expandDisabled = _this$props5.expandDisabled;
      var _this$props6 = this.props,
          disabledArray = _this$props6.disabledArray,
          expandedArray = _this$props6.expandedArray;
      return nodes.map(function (node, index) {
        var key = node.value;
        var accordionId = index;

        var checked = _this5.getCheckState(node);

        var children = _this5.renderChildNodes(node, level);

        return /*#__PURE__*/React.createElement(TreeNode, {
          key: key,
          checked: checked,
          className: node.className,
          disabled: disabledArray.includes(node.value) || disabled,
          expandDisabled: expandDisabled,
          expanded: expandedArray.includes(node.value),
          label: node.label,
          id: accordionId,
          rawChildren: node.children,
          value: node.value,
          onCheck: _this5.onCheck,
          onExpand: _this5.onExpand,
          content: node.content,
          level: level
        }, /*#__PURE__*/React.createElement("div", {
          role: "group"
        }, children));
      });
    } // eslint-disable-next-line arrow-body-style

  }, {
    key: "render",
    value: function render() {
      var nodes = this.props.nodes;
      return /*#__PURE__*/React.createElement("ul", {
        className: "checkboxtree",
        role: "tree"
      }, this.renderTreeNodes(this.getFormattedNodes(nodes)));
    }
  }]);

  return CheckboxTree;
}(Component);

_defineProperty(CheckboxTree, "propTypes", {
  nodes: PropTypes.arrayOf(nodeShape).isRequired,
  disabled: PropTypes.bool,
  expandDisabled: PropTypes.bool,

  /** Array of the checked items */
  checkedArray: PropTypes.array,

  /** Array of the expanded items */
  expandedArray: PropTypes.array,

  /** Array of the disabled items */
  disabledArray: PropTypes.array,

  /** Pass the checked, expanded, disabled states on load */
  onLoad: PropTypes.func,

  /** Pass the checked state on node getting checked/unchecked */
  onCheck: PropTypes.func,

  /** Pass the expanded state on node getting expanded */
  onExpand: PropTypes.func
});

_defineProperty(CheckboxTree, "defaultProps", {
  checkedArray: [],
  disabledArray: [],
  expandedArray: [],
  disabled: false,
  expandDisabled: false,
  onCheck: function onCheck() {},
  onExpand: function onExpand() {},
  onLoad: function onLoad() {}
});

CheckboxTree.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "onCheck",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }],
    "returns": null
  }, {
    "name": "onExpand",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getFormattedNodes",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nodes",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getCheckState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }],
    "returns": null
  }, {
    "name": "getDisabledState",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }, {
      "name": "parent",
      "type": null
    }],
    "returns": null
  }, {
    "name": "isEveryChildChecked",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }],
    "returns": null
  }, {
    "name": "isSomeChildChecked",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderTreeNodes",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nodes",
      "type": null
    }, {
      "name": "level",
      "type": null
    }],
    "returns": null
  }, {
    "name": "renderChildNodes",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "node",
      "type": null
    }, {
      "name": "level",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "CheckboxTree",
  "props": {
    "checkedArray": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Array of the checked items"
    },
    "disabledArray": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Array of the disabled items"
    },
    "expandedArray": {
      "defaultValue": {
        "value": "[]",
        "computed": false
      },
      "type": {
        "name": "array"
      },
      "required": false,
      "description": "Array of the expanded items"
    },
    "disabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "expandDisabled": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "onCheck": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the checked state on node getting checked/unchecked"
    },
    "onExpand": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the expanded state on node getting expanded"
    },
    "onLoad": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": "Pass the checked, expanded, disabled states on load"
    },
    "nodes": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "custom",
          "raw": "nodeShape"
        }
      },
      "required": true,
      "description": ""
    }
  }
};
export default CheckboxTree;